module.exports = Promise.resolve(module.bundle.root("cSpEz"))